export default __webpack_public_path__ + "static/media/domestic_vendor.1e2c3082.xlsx";